import { render, staticRenderFns } from "./TopOrganisersFeed.vue?vue&type=template&id=657a642b&scoped=true&"
import script from "./TopOrganisersFeed.vue?vue&type=script&lang=js&"
export * from "./TopOrganisersFeed.vue?vue&type=script&lang=js&"
import style0 from "./TopOrganisersFeed.vue?vue&type=style&index=0&id=657a642b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a642b",
  null
  
)

export default component.exports